import { Component, OnInit } from '@angular/core';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { FacebookLoginProvider } from '@abacritt/angularx-social-login';
import {Subscription} from 'rxjs';
import {Cookie} from '../../helper/cookie';
import * as fromTrial from '../../profile/trial/store/trial.reducers';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import * as AuthActions from '../store/auth.actions';


@Component({
    selector: 'app-signup-fb',
    templateUrl: './signup-fb.component.html',
    styleUrls: ['./signup-fb.component.scss'],
    standalone: false
})
export class SignupFbComponent implements OnInit {

  cookies: Cookie;
  trialSubscription: Subscription;
  steps: any;
  clicked: boolean;

  constructor(
    private authService: SocialAuthService,
    public store: Store<fromApp.AppState>
  ) {
    this.cookies = new Cookie();
  }

  ngOnInit() {
    this.clicked = false;
    this.authService.authState.subscribe((user) => {
      const url = this.getNextUrl();
      // this.user = user;
      // this.loggedIn = (user != null);
      if (user !== null && user.provider === 'FACEBOOK') {
        const token = user.authToken;
        if (this.clicked) {
          this.store.dispatch(
            new AuthActions.TrySingupByFacebook({
              accessToken: token,
              params: {
                uid: this.cookies.getCookie('auditor-uid'),
                redirectAfterSave: true,
                redirectUrl: url
              }
            })
          );
        }
      }

    });

    this.trialSubscription = this.store.select('trial').subscribe(
      (state: fromTrial.State) => {
        this.steps = state.steps;
      }
    );
  }

  getNextUrl() {
    const version = +this.cookies.getCookie('auditor-version');
    let url = ['/user/register/type'];
    if (version === 4) {
      url = ['/audits'];
    }
    if (version === 3) {
      url = this.steps.payment.url;
    }
    if (version === 5) {
      url = this.steps.payment.url;
    }

    return url;
  }

  signInWithFB(): void {
    this.clicked = true;
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

}
